/* eslint-disable no-restricted-syntax */
import moment from "moment";
import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import SweetAlert from "sweetalert2";
import { queryDateFormat } from "../../../config/constants";
import { useAuth } from "../../context/AuthContext";
import useFetcher from "../../hooks/useFetcher";
import { handleErrors } from "../../services/handleErrors";
import { fetchTaskCategories, patchTasks } from "../../services/taskServices";
import { taskUtil } from "../../utils/taskUtil";
import modulos from "../../mocks/modulos";

const TaskListTableCentralizer = ({ tasks, novedades, handleClickTask, newTaskUpdated, centralizer, withClientData }) => {
  const { currentUser } = useAuth();
  const isAdmin = currentUser && currentUser.haveAdminAccess(modulos.CALENDAR);
  const orderedTasks =
    tasks &&
    tasks.sort((a, b) => {
      const statusOrder = {
        pendiente: 1,
        vencido: 2,
        resuelto: 3,
      };

      return statusOrder[a.status] - statusOrder[b.status];
    });

  const today = moment().format(queryDateFormat);
  const [currentPage, setCurrentPage] = useState();

  const [categories] = useFetcher(fetchTaskCategories);
  const taskTypes = categories.type;

  const getNovedad = (tarea) => {
    return novedades && novedades.find((novedad) => novedad.id === tarea.novedadId);
  };
  const getTaskTypeStr = (typeId) => {
    const { text } = taskTypes.find((task) => task.id === typeId);
    return text;
  };

  const handleTogleCheckCentralizer = async (taskId) => {
    try {
      const taskToUpdate = tasks.find((el) => el.id === taskId);
      const cliente = getNovedad(taskToUpdate).cliente.razonSocial;
      const tasksCentralized = orderedTasks.filter((t) => {
        return t.title === taskToUpdate.title && cliente === getNovedad(t).cliente.razonSocial && t.centralizer;
      });
      // const findCompleteDate = tasksCentralized.find((t) => {
      //   return t.completeDate;
      // });
      // cambio la logica. Si hay al menos una tarea sin resolver, se busca resolver todo.
      const hasNullCompleteDate = tasksCentralized.some((t) => t.completeDate === null);
      let messageAlert = "";
      for (const task of tasksCentralized) {
        // task.completeDate = null;
        const novedad = getNovedad(task);
        const subCliente = novedad && novedad.cliente.numeroDeLegajo.replace(".0000", "").padStart(7, 0);
        const sucursal = novedad && novedad.sucursal.titulo;
        messageAlert += `${subCliente} - ${sucursal} <br/>`;
      }

      if (!hasNullCompleteDate) {
        const { isConfirmed } = await SweetAlert.fire({
          title: `¿Esta seguro de rechazar la tarea? Afectará a:`,
          html: ` ${messageAlert} <br/> Una vez rechazada, se le enviará una notificación al responsable`,
          icon: "warning",
          confirmButtonColor: "#bf0d3e",
          showCancelButton: true,
          showConfirmButton: true,
        });
        if (isConfirmed) {
          for (const task of tasksCentralized) {
            task.completeDate = null;
          }
          const { result } = await patchTasks(tasksCentralized);
          const message = "Tarea rechazada exitosamente";

          if (result) {
            newTaskUpdated(result);
            toast.success(message);
          }
        }
      } else {
        const { isConfirmed } = await SweetAlert.fire({
          title: `¿Esta seguro de resolver la tarea? Afectará a:`,
          html: ` ${messageAlert}`,
          icon: "warning",
          confirmButtonColor: "#bf0d3e",
          showCancelButton: true,
          showConfirmButton: true,
        });
        if (isConfirmed) {
          for (const task of tasksCentralized) {
            task.completeDate = today;
          }
          const { result } = await patchTasks(tasksCentralized);
          const message = "Tarea resuelta exitosamente";
          if (result) {
            newTaskUpdated(result);
            toast.success(message);
          }
        }
      }
    } catch (error) {
      handleErrors(error, toast.error);
    }
  };

  const getCentralizedTasks = () => {
    const filteredTasks = [];
    const tasksTypes = ["Sucursal", "Nóminas", "Facturación", "Cobranzas"];
    const clientsList = [];

    for (const task of tasks) {
      const novedad = getNovedad(task);
      if (novedad) {
        if (!clientsList.includes(novedad.cliente.razonSocial)) {
          clientsList.push(novedad.cliente.razonSocial);
        }
      }
    }

    for (const client of clientsList) {
      for (const type of tasksTypes) {
        const find = tasks.find((t) => {
          return t.title === type && client === getNovedad(t).cliente.razonSocial && t.centralizer;
        });
        if (find) {
          filteredTasks.push(find);
        }
      }
    }
    if (!isAdmin) {
      const memberTasks = filteredTasks.filter((task) => {
        return currentUser.user.Pi.itemId === task.responsableId || currentUser.user.Pi.itemId === task.liderId;
      });
      return memberTasks;
    }
    return filteredTasks;
  };

  const ordererCentralizedTasks = getCentralizedTasks();

  const nextToCompleteIndexCentralized = ordererCentralizedTasks && ordererCentralizedTasks.findIndex((task) => task.completeDate === null);

  return (
    <div className="table-responsive support-table" style={{ marginTop: !withClientData ? "45px" : "" }}>
      <DataTable
        title={withClientData ? "Tareas" : null}
        paginationComponentOptions={{ rowsPerPageText: "Tareas por pagina", rangeSeparatorText: "De", selectAllRowsItemText: "Todas" }}
        paginationDefaultPage={currentPage}
        onChangePage={(page) => setCurrentPage(page)}
        noDataComponent={
          <div className="p-3">
            <b>No se encontraron tareas</b>
          </div>
        }
        striped
        pagination
        data={centralizer && getCentralizedTasks()}
        columns={[
          {
            name: "#",
            // eslint-disable-next-line radix
            selector: (tarea) => (
              <button className="btn btn-link" type="button" onClick={() => handleClickTask(tarea)}>
                Ver
              </button>
            ),
            sortable: false,
            center: true,
            id: "link",
          },
          {
            name: "Cliente",
            selector: (tarea) => getNovedad(tarea) && getNovedad(tarea).cliente.razonSocial,

            center: true,
            wrap: true,
            id: "cliente",
            style: {
              cursor: "pointer",
              textAlign: "center",
            },
            width: "200px",
          },
          {
            name: "Responsable",
            selector: (tarea) => tarea.responsable && tarea.responsable.nombreApellido,

            center: true,
            wrap: true,
            id: "responsable",
          },
          {
            name: "Tipo",
            selector: (tarea) => taskTypes && getTaskTypeStr(tarea.type),

            center: true,
            wrap: true,
            id: "tipo",
          },
          {
            name: "Vencimiento",
            selector: (tarea) => moment(tarea.dueDate).format(queryDateFormat),

            center: true,
            wrap: true,
            id: "vencimiento",
          },
          {
            name: "Resolución",
            selector: (tarea) => (tarea.completeDate ? moment(tarea.completeDate).format(queryDateFormat) : "-"),

            center: true,
            wrap: true,
            id: "resolucion",
          },
          {
            name: "Estado",
            selector: (tarea) => taskUtil(tarea).statusHtml(),
            sortFunction: (tarea) => taskUtil(tarea).statusStr(),

            center: true,
            id: "estado",
          },
          {
            name: " ",
            selector: (tarea, i) => (
              <>
                <span className="task-action-btn">
                  {taskUtil(tarea).statusCheck(handleTogleCheckCentralizer, currentUser, ordererCentralizedTasks, i, nextToCompleteIndexCentralized, centralizer)}
                </span>
              </>
            ),
            center: true,
            id: "check",
          },
        ]}
      />
    </div>
  );
};

export default TaskListTableCentralizer;
